import { useTranslationWithPrefix } from '@hotjar/translations';
import styled from '@emotion/styled';
import { Link, Stack, Icon, Text } from '@hotjar/hotsauce';

const S = {
  CapitalizedText: styled(Text)`
    text-transform: capitalize;
  `,
  Link: styled(Link)`
    white-space: nowrap;
  `,
  Stack: styled(Stack)`
    align-items: center;
  `,
};

const PRICING_MODEL_CHANGES_URL = 'https://www.hotjar.com/blog/updating-our-pricing-model/';

interface ActionRequiredInfoProps {
  subscriptionEndDate?: string;
  actionRequiredWideLayout: boolean;
}

export function ActionRequiredInfo({
  subscriptionEndDate,
  actionRequiredWideLayout,
}: ActionRequiredInfoProps): JSX.Element {
  const { t: tSubscriptions } = useTranslationWithPrefix('checkout:wizard.subscriptions');
  return (
    <S.Stack direction="row" spacing="x2">
      <S.CapitalizedText textType="subtitle2" textColor="text_light">
        {tSubscriptions('action-required.unlimited-responses')}
      </S.CapitalizedText>
      <Text textType="body2" textColor="text_danger">
        <Icon icon="warning" inline size="m" />{' '}
        {tSubscriptions('action-required.only-until', {
          subscriptionEndDate,
          context: actionRequiredWideLayout ? 'wide_layout' : 'narrow_layout',
        })}
      </Text>
      <Text textType="body2">
        <S.Link href={PRICING_MODEL_CHANGES_URL} kind="standalone" isExternal>
          {tSubscriptions('action-required.learn-more')}
        </S.Link>
      </Text>
    </S.Stack>
  );
}
